import styled from "styled-components";

export const ActionBar = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;

  text-align: right;

  > :not(:last-child) {
    margin-right: 10px;
  }
`;
